<template>
  <div>
    <div style="margin-bottom: 2.8125rem">
      {{ $t('inviteTextHeader') }}
    </div>
    <CandidateCreateForm
      :invitation-type="invitationType.ONLINE_INTERVIEW"
      :vacancy="vacancy"
      @cancel="cancel"
      @created="$emit('created',$event)"
    />
  </div>
</template>

<script>
import { invitationType } from '@/enums';
import CandidateCreateForm from '../../forms/CandidateCreateForm.vue';

export default {
  name: 'PersonalInvitation',
  components: {
    CandidateCreateForm,
  },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      invitationType,
    };
  },
  methods: {
    cancel() {
      this.$emit('input', false);
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
inviteTextHeader: Send the candidates a link to the video interview in any convenient way (job site, messenger, etc.).
</i18n>

<i18n locale="ru" lang="yaml">
inviteTextHeader: Отправьте кандидатам ссылку на видео-интервью любым удобным способом (job-сайт, мессенджер и т.п.).
</i18n>
